import { UploadCloud, FileSpreadsheet, Sparkles, FileCheck2 } from 'lucide-react';

const STEPS = [
  { icon: UploadCloud, title: 'Sube el extracto bancario.' },
  { icon: FileSpreadsheet, title: 'Sube el auxiliar contable.' },
  { icon: Sparkles, title: 'Conciliabanco encuentra las coincidencias.' },
  { icon: FileCheck2, title: 'Consulta el resultado y descarga el informe.' },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy-900 tracking-tight">
            Conciliar nunca fue tan fácil.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((step, i) => (
            <div
              key={step.title}
              className="relative rounded-2xl bg-white border border-slate-200 p-7 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <span className="absolute -top-3.5 -left-3.5 flex items-center justify-center w-9 h-9 rounded-full bg-navy-900 text-white text-sm font-bold shadow-md">
                {i + 1}
              </span>
              <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-brand-green/10 text-brand-greenDark mb-5">
                <step.icon size={24} />
              </span>
              <p className="font-semibold text-navy-900 leading-snug">{step.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
